import { AppliedPricingCardPrice } from './applied-pricing-card-price';
import { AppliedProtectionPrice } from './applied-protection-price';
import { LongStayRate } from './long-stay-rate';

export class ClientPricing {
	superhogUserId: string;
	accountCurrencyId?: number | null;
	/** The currency every price and long stay rate is shown in: the one asked for, else the account currency. */
	currencyId?: number | null;
	/** Every currency, ascending, in which the client holds a live own card or long stay rate, whatever currencyId is. */
	ownPriceCurrencyIds?: number[];
	protectionPrices: AppliedProtectionPrice[];
	prices: AppliedPricingCardPrice[];
	/** The client's live long stay rows in currencyId: at most one all-levels row per basis, plus level overrides. */
	longStayRates: LongStayRate[];
}
